export const formatVND = (amount: number) => {
  if (amount === undefined || amount === null || isNaN(Number(amount))) {
    return "";
  }
  return new Intl.NumberFormat("vi-VN", {
    // style: 'currency',
    style: "decimal",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
